// extracted by mini-css-extract-plugin
module.exports = {"todo":"todo_todo__OYSuR"};